<div class="d-flex align-items-center">
  <fa-icon class="me-4"
           [icon]="['fab', 'apple']"></fa-icon>
  <div class="flex-grow-1 lh-1 text-truncate">
    <h6 class="mb-1">{{ selectedApplication?.bundleName }}</h6>
    <p class="mb-0 lh-1 text-truncate">
      <small class="text-truncate">{{ selectedApplication?.bundleIdentifier }}</small>
    </p>
  </div>
  @if (!hideVersionSelector()) {
    <div class="row g-2">
      <div class="col-auto">
        <label for="appVersionSelect"
               class="col-form-label"
               i18n>Version:</label>
      </div>
      <div class="col-auto">
        <select class="form-select"
                id="appVersionSelect"
                (change)="selectVersion($event.target.value)">
          @for (version of versions; track version) {
            <option [value]="version">{{ version }}</option>
          }
        </select>
      </div>
    </div>
  }
</div>